const config = {
    build_number: '601845',
    build_timestamp: '2025-05-22T16:48:14.449Z',
    build_commit: '3aa7473b915b246fe95869c273fe031980715cf8',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
